import { Grid } from "@talentech/components";

const TopRated = () => {
  return (
    <>
      <div className="container-fluid bg-light">
        <div className="container">
          <div className="row text-center py-4">
            <Grid item xs={6} className="offset-3 py-4">
              <p className="fz-5 h4 fw-light text-center">
                <strong className="fw-bold">
                  The complete recruitment and HR platform.{" "}
                </strong>
                Say goodbye to patching together different HR systems with
                limited insights and direction and say hello to one unified
                recruitment and HR platform that lets you{" "}
                <strong className="fw-bold">
                  work data driven, do more with less, and drive real growth
                </strong>
                .&nbsp;
              </p>
            </Grid>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row text-center d-flex justify-content-center align-items-center">
          <div className="col-md-3 col-sm-6 mb-4 mb-md-0">
            <h6 className="h2 fw-bold" style={{ color: "#000000" }}>
              Top rated
            </h6>
            <p className="mb-0">
              <em style={{ color: "#000000" }}>Value for money</em> and{" "}
              <em style={{ color: "#000000" }}>customer satisfaction</em>
            </p>
          </div>
          <div className="col-md-3 col-sm-6 mb-4 mb-md-0">
            <h6 className="h2 fw-bold">+ 2500</h6>
            <p className="mb-0">customers</p>
          </div>
          <div className="col-md-3 col-sm-6 mb-4 mb-sm-0">
            <h6 className="h2 fw-bold">600000+</h6>
            <p className="mb-0">users</p>
          </div>
          <div className="col-md-3 col-sm-6 bg-primary py-4">
            <div className="h-100 p-3 px-4 ">
              <h4 className="text-white">
                The complete recruitment <br /> &amp; HR platform
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid bg-light py-4">
        <div className="container py-4">
          <div className="row py-4 mb-4">
            <div className="col-8">
              <h3 className="h2 fw-light">
                With Talentech, you will get an easy-to-use, all-in-one
                recruitment and HR platform designed for growing businesses
              </h3>
            </div>
          </div>
          <div className="row">
            {boxes.map((box, index) => (
              <div className="col-md-4" key={index}>
                <div>
                  <img src={box.image} alt={box.title} className="img-fluid" />
                  <h3 className="h4 mt-3">{box.title}</h3>
                  <p>{box.content}</p>
                  <p className="text-muted fst-italic">{box.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TopRated;

const boxes = [
  {
    image: "https://talentech.com/wp-content/uploads/2024/03/1.png",
    title: "Everything in one place",
    content:
      "The complete platform to find the right talents and build thriving teams that drive growth - no more juggling multiple systems – or defending multiple invoices.",
    summary: "Get better overview | Save time | Work smarter",
  },
  {
    image: "https://talentech.com/wp-content/uploads/2024/03/2-1.png",
    title: "Data-driven:",
    content:
      "Leverage secure AI with unique, real-time data and insights to make better and more confident decisions, without needing an HR analyst.",
    summary: "Feel confident | Make the right decisions | Easy KPI overview",
  },
  {
    image: "https://talentech.com/wp-content/uploads/2024/03/3-3.png",
    title: "Built for execution:",
    content:
      "Get a recruitment and HR platform so simple and intuitive that your managers will actually use it and start driving the strategy you have set out.",
    summary: "Empower your managers | Get more things done",
  },
];
